import { render, staticRenderFns } from "./EventEditorInviteForm.vue?vue&type=template&id=0bc1ef30"
import script from "./EventEditorInviteForm.vue?vue&type=script&lang=ts"
export * from "./EventEditorInviteForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports